var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333328C7.79992 0.333328 0.333252 7.8 0.333252 17C0.333252 26.2 7.79992 33.6667 16.9999 33.6667C26.1999 33.6667 33.6666 26.2 33.6666 17C33.6666 7.8 26.1999 0.333328 16.9999 0.333328ZM16.9999 5.33333C19.7666 5.33333 21.9999 7.56666 21.9999 10.3333C21.9999 13.1 19.7666 15.3333 16.9999 15.3333C14.2333 15.3333 11.9999 13.1 11.9999 10.3333C11.9999 7.56666 14.2333 5.33333 16.9999 5.33333ZM16.9999 29C12.8333 29 9.14992 26.8667 6.99992 23.6333C7.04992 20.3167 13.6666 18.5 16.9999 18.5C20.3166 18.5 26.9499 20.3167 26.9999 23.6333C24.8499 26.8667 21.1666 29 16.9999 29Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.b63a1f23.svg";
export { ForwardRef as ReactComponent };